import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import * as actions from '../actions'
import AppBar from 'material-ui/AppBar';
import MenuItem from 'material-ui/MenuItem';
// import RaisedButton from 'material-ui/RaisedButton';
import Drawer from 'material-ui/Drawer';
import IconButton from 'material-ui/IconButton';
import NavigationClose from 'material-ui/svg-icons/navigation/close';
import NavigationOpen from 'material-ui/svg-icons/image/dehaze';
import FloatingActionButton from 'material-ui/FloatingActionButton';
import ArrowDropRight from 'material-ui/svg-icons/navigation-arrow-drop-right';
// import ArrowDropRight from 'material-ui/svg-icons/navigation-arrow-drop-right';
// const uuidv4 = require('uuid/v4');

const styles = {
  leftTop: {
    position: "fixed",
    top: 4,
    left: 4,
    zIndex: 1400,
  },
}
class Header extends Component {

  constructor(props) {
    super(props);
    this.state = {menuOpen: false};
    // this.props.refreshUser()
  }

  componentWillMount() {
  }

  scrollTo = (element, to, duration) => {
      //t = current time
      //b = start value
      //c = change in value
      //d = duration
      Math.easeInOutQuad = function (t, b, c, d) {
        t /= d/2;
        if (t < 1) return c/2*t*t + b;
        t--;
        return -c/2 * (t*(t-2) - 1) + b;
      };

      var start = element.scrollTop,
          change = to - start,
          currentTime = 0,
          increment = 20;
          
      var animateScroll = function(){        
          currentTime += increment;
          var val = Math.easeInOutQuad(currentTime, start, change, duration);
          element.scrollTop = val;
          if(currentTime < duration) {
              setTimeout(animateScroll, increment);
          }
      };
      animateScroll();
  }

  handleToggle = () => {
    if (this.state.menuOpen === true) {
      window.scroll(0,0)
    }
    this.setState({menuOpen: !this.state.menuOpen});
  }

  handleClose = () => this.setState(
    {menuOpen: false})
  ;

  renderMenuButton() {
    if (this.props.authenticated) {
      return [
        <FloatingActionButton
          key={1}
          style={styles.leftTop}
          onClick={this.handleToggle}
          zDepth={0}
        >
          {this.state.menuOpen ? <NavigationClose /> : <NavigationOpen />}
        </FloatingActionButton>
      ]
    } else {
      return [
        <div key={1}></div>
      ]
    }
  }

  renderLinks() {
    if (this.props.authenticated) {
      // var uu = uuidv4()
      // uu = "/persons/"+uu;
      return [
        <MenuItem key={2} className="nav-item" onClick={this.handleToggle}>
          <Link className="nav-link" to="/persons">Személyek</Link>
        </MenuItem>,
        <MenuItem key={31} className="nav-item" onClick={this.handleToggle}>
          <Link className="nav-link" to="/self-knowledge-groups">Önismereti csoportok</Link>
        </MenuItem>,
        <MenuItem key={32} className="nav-item" onClick={this.handleToggle}>
          <Link className="nav-link" to="/training-groups">Képzési csoportok</Link>
        </MenuItem>,
        <MenuItem key={4} className="nav-item" onClick={this.handleToggle}>
          <Link className="nav-link" to="/fees">Befizetések</Link>
        </MenuItem>,
        <MenuItem key={5} className="nav-item" onClick={this.handleToggle}>
          <Link className="nav-link" to="/tb">TB ügyek</Link>
        </MenuItem>,
        <MenuItem
          primaryText="Statisztikák"
          key={6}
          className="nav-item"
          rightIcon={<ArrowDropRight />}
          //onClick={this.handleToggle}
          menuItems={[
            <MenuItem key={61} className="nav-item" onClick={this.handleToggle}>
              <Link className="nav-link" to="/feestatistics">Befizetések</Link>
            </MenuItem>,
            <MenuItem key={62} className="nav-item" onClick={this.handleToggle}>
              <Link className="nav-link" to="/tbstatistics">TB Ügyek</Link>
            </MenuItem>,
            <MenuItem key={63} className="nav-item" onClick={this.handleToggle}>
              <Link className="nav-link" to="/groupstatistics">Csoportok</Link>
            </MenuItem>,
          ]}
        />,
        <MenuItem key={7} className="nav-item" onClick={this.handleToggle}>
          <Link className="nav-link" to="/settings">Beállítások</Link>
        </MenuItem>,
        <MenuItem key={1} className="nav-item">
          <Link className="nav-link" to="/signout" onClick={this.handleClose}>Kijelentkezés</Link>
        </MenuItem>
      ]
    } else {
      return [
        <MenuItem key={1} className="nav-item">
          <Link className="nav-link" to="/signin">Bejelentkezés</Link>
        </MenuItem>
      ]
    }
  }

  render() {
    return (
      <div>
        {this.renderMenuButton()}
        <Drawer
          docked={false}
          open={this.state.menuOpen}
          onRequestChange={(menuOpen) => this.setState({menuOpen})}
        >
          <AppBar
            title={<span>MPE</span>}
            //onTitleClick={this.handleClose}
            iconElementLeft={
              <IconButton>
                <NavigationOpen />
              </IconButton>
            }
          />
          {this.renderLinks()}
        </Drawer>
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    authenticated: state.auth.authenticated
  }
}

export default connect(mapStateToProps, actions)(Header)


// WEBPACK FOOTER //
// ./src/components/header.js